<template>
    <v-dialog v-model="dialog" content-class="modal-dialog">
        <v-card class="modal-lighting-history">
            <div class="common-text mb-2">
                История включения/выключения света
            </div>
            <v-layout column ma-0 class="main-text mb-5 w-100 lighting-list scrollbar-block">
                <v-flex xs12 class="text-center grey-text" v-if="lightingHistory.length == 0">
                     Нет доступной истории
                </v-flex>
                <v-flex v-else xs12 v-for="(action, index) in lightingHistory" :key="index" class="lightings">
                    <v-layout v-if="action.new_day" class="lightings__title bold-text">
                        {{action.new_day}}
                    </v-layout>
                    <v-flex class="lighting-row" v-if="action.state">
                        <div class="d-inline-flex mr-3" v-if="action.state.value">
                            <v-img max-height="30px" max-width="30px" :src="require('@/assets/device-icons/lighting.svg')" class="d-inline-flex"/>
                        </div>
                        <div class="d-inline-flex mr-3" v-else>
                            <v-img max-height="30px" max-width="30px" :src="require('@/assets/device-icons/lighting_off.svg')" class="d-inline-flex"/>
                        </div>
                        <div class="d-inline-flex">
                            время: {{action.start_updated}}
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <v-flex class="d-flex w-100 justify-end mt-6">
                <v-btn class="btn-grey main-text" @click="close">
                    Закрыть
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
import {getTimeFromDate} from "@/utils";
import { timeWithTZ } from '@/utils/index';

export default {
    name: "ModalLightingHistory",
    props: {
        value: {
            type: Boolean,
        },
        history: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            dialog: false,
            lightingHistory: [],
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
            }
        },
        dialog(val) {
            if (!val) {
                this.$emit('input', false);
            }
        },
        history(val) {
            if (val) {
                this.setLightingHistory();
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
            this.$emit('input', false);
        },
        checkDay(day) {
            return timeWithTZ(day).split('T')[0];
        },
        reverseDate(time) {
            const [year, month, day] = time.split("-");
            return day + "." + month + "." + year;
        },
        setLightingHistory() {
            this.lightingHistory = JSON.parse(JSON.stringify(this.history));
            this.lightingHistory.forEach((lighting, index) => {
                lighting.start_updated = getTimeFromDate(lighting.date);
                if (index > 0) {
                    if (this.checkDay(lighting.date) != this.checkDay(this.lightingHistory[index - 1].date)) {
                        lighting.new_day = this.checkDay(lighting.date);
                        lighting.new_day = this.reverseDate(lighting.new_day);
                    }
                } else {
                    lighting.new_day = this.checkDay(lighting.date);
                    lighting.new_day = this.reverseDate(lighting.new_day);
                }
            });
        },
        formattedDuration(val) {
            val = parseInt(val);
            if (val >= 60) {
                let minutes = Math.floor(val / 60);
                let seconds = val % 60;
                let hours = Math.floor(minutes / 60);
                minutes = minutes % 60;
                let row = "";
                if (hours) {
                    row = hours + " ч.";
                }
                if (minutes) {
                    if (hours) {
                        row += " " + minutes + " мин.";
                    }
                    else {
                        row += minutes + " мин.";
                    }
                }
                if (seconds) {
                    if (hours || minutes) {
                        row += " " + seconds + " сек.";
                    } else {
                        row += seconds + " сек.";
                    }
                }
                return row;
            }
            return val + " сек.";
        },
    }

}
</script>

<style lang="scss" scoped>
.modal-lighting-history.v-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .lighting-list {
        min-height: 400px;
        max-height: 60vh;
        overflow-y: auto;
    }

    .lightings {
        &:not(:last-child) {
            border-bottom: 1px solid #787878;
        }

        &__title {
            margin: 10px 0;
            background: #ffd9b3;
            justify-content: center;
            border-radius: 30px;
        }

        .lighting-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            min-height: 38px;

            &:not(:last-child) {
                border-bottom: 1px solid #787878;
            }

            .v-image{
                max-height: 32px;
                max-width: 32px;
            }
        }
    }
}

.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
}
</style>